import { apis } from 'utils/lib/apis';
//  -- Actions ------------------------
import { logToSentry } from "utils/networkErrorUtils";
// import { sortBy } from "lodash";
import * as wordBankActions from "./actions";
// import axios from "axios";

export const handleGenerateVocabularyForWordBank =
  (data) => async (dispatch) => {
    try {
      const vocabularyData = await apis.post(
        "vocabularyRDS",
        `/generate_inappropriate_vocabulary`,
        {
          body: data,
        }
      );
      if (vocabularyData && vocabularyData.id) {
        await dispatch(wordBankActions.addWordBank(vocabularyData));
      }
      return vocabularyData;
    } catch (error) {
      if (error) {
        logToSentry({
                message: 'generating vocabulary for word bank',
                error,
                module: 'WORD_BANK',
                operation: 'GET_VOCABULARY_FEEDBACK_WORD_BANK'
            });
        return null;
      }
    }
  };

export const handleListWordBank = (data) => async (dispatch) => {
  try {
    const vocabularyData = await apis.post(
      "vocabularyRDS",
      `/list_inappropriate_vocabulory`,
      {
        body: data,
      }
    );
    if (vocabularyData) {
      await dispatch(wordBankActions.setWordBank(vocabularyData));
    }
    return vocabularyData;
  } catch (error) {
    if (error) {
      logToSentry({
                message: 'listing word bank',
                error,
                module: 'WORD_BANK',
                operation: 'LIST_WORD_BANK'
            });
      return null;
    }
  }
};
export const handleDeleteWordBank = (id) => async (dispatch) => {
  try {
    const vocabularyData = await apis.del(
      "vocabularyRDS",
      `/delete_inappropriate_vocab/${id}`
    );
    if (vocabularyData) {
      await dispatch(wordBankActions.deleteWordBank(id));
    }
    return vocabularyData;
  } catch (error) {
    if (error) {
      logToSentry({
                message: 'deleting word bank',
                error,
                module: 'WORD_BANK',
                operation: 'DELETE_WORD_BANK'
            });
      return null;
    }
  }
};

export const handleUpdateWordBank = (data) => async (dispatch) => {
  try {
    const vocabularyData = await apis.post(
      "vocabularyRDS",
      `/udapte_word_bank`,
      {
        body: data,
      }
    );
    if (vocabularyData) {
      await dispatch(wordBankActions.updateWordBank(data));
    }
    return vocabularyData;
  } catch (error) {
    if (error) {
      logToSentry({
                message: 'updating word bank',
                error,
                module: 'WORD_BANK',
                operation: 'UPDATE_WORD_BANK'
            });
      return null;
    }
  }
};

export const handleGenerateCognateWordBank = (data) => async (dispatch) => {
  try {
    const vocabularyData = await apis.post(
      "vocabularyRDS",
      `/generate_cognets_word_bank`,
      {
        body: data,
      }
    );
    if (vocabularyData) {
      await dispatch(wordBankActions.addWordBank(vocabularyData));
    }
    return vocabularyData;
  } catch (error) {
    if (error) {
      logToSentry({
                message: 'generating cognate word bank',
                error,
                module: 'WORD_BANK',
                operation: 'GET_CLASS_WORD_BANK'
            });
      return null;
    }
  }
}

export const handleGenerateCognateWordBankNonNative = (data) => async (dispatch) => {
  try {
    const vocabularyData = await apis.post(
      "vocabularyRDS",
      `/generate_with_modes_bank`,
      {
        body: data,
      }
    );
    if (vocabularyData) {
      await dispatch(wordBankActions.addWordBank(vocabularyData));
    }
    return vocabularyData;
  } catch (error) {
    if (error) {
      logToSentry({
                message: 'generating cognate word bank non native',
                error,
                module: 'WORD_BANK',
                operation: 'GET_CLASS_WORD_BANK_NOTE_NOTE'
            });
      return null;
    }
  }
}

